import {menu, navigation} from "./modules/Menu.js";
import {setHeaderHeight} from "./modules/setHeaderHeight.js";
import {scrollDown} from "./modules/scrollDown.js";


import.meta.glob([
	'../images/**',
	'../fonts/**',
]);

const loadIfPresent = (selector, callback) => {
	if (document.querySelector(selector)) {
		callback();
	}
};

document.addEventListener('DOMContentLoaded', function () {
	setHeaderHeight();
	menu();
	navigation();
	scrollDown();

	loadIfPresent('#load-more', async () => {
		const {initArchive} = await import("./modules/archive.js");
		initArchive();
	});

	loadIfPresent('.rank-math-breadcrumb', async () => {
		const {initBreadcrumbs} = await import("./modules/breadcrumbs.js");
		initBreadcrumbs();
	});

	loadIfPresent('.hero-v1-swiper, .hero-v2-swiper', async () => {
		const {heroslider} = await import("./modules/swiper.js");
		heroslider();
	});

	loadIfPresent('.card-swiper', async () => {
		const {cardslider} = await import("./modules/swiper.js");
		cardslider();
	});

	loadIfPresent('.product-images-swiper', async () => {
		const {productimagesslider} = await import("./modules/swiper.js");
		productimagesslider();
	});

	loadIfPresent('.gallery-swiper', async () => {
		const {galleryslider} = await import("./modules/swiper.js");
		galleryslider();
	});

	loadIfPresent('.products-swiper', async () => {
		const {productsslider} = await import("./modules/swiper.js");
		productsslider();
	});

	loadIfPresent('.plattenformen-swiper', async () => {
		const {plattenformenslider} = await import("./modules/swiper.js");
		plattenformenslider();
	});

	loadIfPresent('.serie-products-swiper', async () => {
		const {serienproductsslider} = await import("./modules/swiper.js");
		serienproductsslider();
	});

	loadIfPresent('.subCatSwiper', async () => {
		const {subCatSwiper} = await import("./modules/swiper.js");
		subCatSwiper();
	});

	loadIfPresent('lottie-player', () => {
		import("@lottiefiles/lottie-player");
	});

	loadIfPresent('#map', () => {
		const mapElement = document.getElementById('map');

		const observer = new IntersectionObserver((entries) => {
			entries.forEach(async (entry) => {
				if (entry.isIntersecting) {
					// Erst jetzt laden wir das schwere Map-Modul
					const {map} = await import("./modules/map.js");
					map();
					// Observer stoppen, da Karte geladen ist
					observer.unobserve(mapElement);
				}
			});
		}, {rootMargin: '200px'}); // Lädt 200px bevor die Karte ins Bild kommt

		observer.observe(mapElement);
	});

	loadIfPresent('.js-animate, .social-media-icon', () => {
		if ('requestIdleCallback' in window) {
			requestIdleCallback(async () => {
				const {animations} = await import("./modules/animations.js");
				animations();
			});
		} else {
			setTimeout(async () => {
				const {animations} = await import("./modules/animations.js");
				animations();
			}, 200); // Kleiner Delay als Fallback
		}
	});

	loadIfPresent('.search-toggle, .search-icon', async () => {
		const {openSearchbox} = await import("./modules/openSearchbox.js");
		openSearchbox();
	});

	loadIfPresent('.video-wrapper, video, iframe, .wp-block-media-text', async () => {
		const {media} = await import("./modules/media.js");
		media();
	});

	loadIfPresent('.bommel', async () => {
		const {bommel} = await import("./modules/bommel.js");
		bommel();
	});

	loadIfPresent('.contactPopupButton', async () => {
		const {contactPopup} = await import("./modules/contactPopup.js");
		contactPopup();
	});

	loadIfPresent('.popup', async () => {
		const {popup} = await import("./modules/popup.js");
		popup();
	});

	loadIfPresent('form', async () => {
		const {form} = await import("./modules/form.js");
		form();
	});

	loadIfPresent('.colorSwitcher', async () => {
		const {contrastSwitch} = await import("./modules/contrastSwitch.js");
		contrastSwitch();
	});

	loadIfPresent('.shop-filter, .widget_layered_nav', async () => {
		const {toggleShopFilter} = await import("./modules/toggleShopFilter.js");
		toggleShopFilter();
	});

	loadIfPresent('.product-accessories-wrapper', async () => {
		const {popupProducts} = await import("./modules/popup-products.js");
		popupProducts();
	});

	loadIfPresent('footer', async () => {
		const {footer} = await import("./modules/footer.js");
		footer();
	});

	loadIfPresent('.accordions', async () => {
		const {blockAccordion} = await import("./blocks/accordions.js");
		blockAccordion();
	});

	loadIfPresent('.auszeichnungen', async () => {
		const {auszeichnungen} = await import("./blocks/auszeichnungen.js");
		auszeichnungen();
	});

	loadIfPresent('.ctaSection', async () => {
		const {cta} = await import("./blocks/cta.js");
		cta();
	});

	loadIfPresent('.einleitungstext', async () => {
		const {einleitungstext} = await import("./blocks/einleitungstext.js");
		einleitungstext();
	});

	loadIfPresent('.iconteaser', async () => {
		const {iconteaser} = await import("./blocks/iconteaser.js");
		iconteaser();
	});

	loadIfPresent('.interactiveShowcase', async () => {
		const {interactiveshowcase} = await import("./blocks/interactiveshowcase.js");
		interactiveshowcase();
	});

	loadIfPresent('.kundenstimmen', async () => {
		const {kundenstimmen} = await import("./blocks/kundenstimmen.js");
		kundenstimmen();
	});

	loadIfPresent('.vertriebler', async () => {
		const {vertriebler} = await import("./blocks/vertriebler.js");
		vertriebler();
	});

}, false);






